import { Divider, Skeleton } from 'antd'
import API from 'API'
import { useAuth } from 'AuthContext'
import PathTabs from 'components/general/PathTabs'
import React, { useEffect, useMemo, useState } from 'react'

const tutorials = [
    {"key": "university", "label": "Nhà trường", role: 1,},
    {"key": "teacher", "label": "Giảng viên", role: 2,},
    {"key": "academic-admin", "label": "Giáo vụ", role: 3,},
    {"key": "student", "label": "Sinh viên", role: 100,},
]

function InvidialTutorial({ item }) {
    const [html, setHTML] = useState("");
    const [getting, setGetting] = useState(true);
    useEffect(() => {
        if (!item) return;
        setGetting(true);
        setHTML("");
        API.get(`/tutorial/${item.key}`)
        .then(res => {
            setHTML(res.data);
        })
        .catch(error => {
            console.log(error);
        })
        .finally(() => {
            setGetting(false);
        })
    },[item])
    return getting ? <Skeleton active/> : <iframe style={{ width: "100%", height: 800 }} srcDoc={html} title={item.label}/>
}

export default function Tutorial() {
    const { user } = useAuth();
    const items = useMemo(() => tutorials.filter(item => item.role >= user.role && (user.role !== 2 || item.role !== 3)).map(item => ({
        ...item, children: <InvidialTutorial key={item.key} item={item}/>
    })),[user])
    return <>
        <Divider style={{ fontSize: 20 }}>
            Hướng dẫn sử dụng hệ thống học tập AI
        </Divider>
        <PathTabs
            basePath="/tutorial"
            titlePath="Hướng dẫn"
            items={items}
        />
    </>
}
